import React from "react";
import Image from "next/image";

const BridgeProgram: React.FC = () => {
  return (
    <>
      <div className="bg-white w-full md:py-[50px] py-8 relative md:bg-bottom bg-center md:bg-[#061A2F] bg-repeat bg-cover bg-[length:100% 100%] relative">
        <Image
          src="/cpa/bg_logo.png"
          alt="Special Offer"
          className="md:block hidden mx-auto absolute bottom-0 left-0"
          width={503}
          height={463}
          priority
        />
        <div className="lg:container mx-auto h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 md:mb-6 relative lg:block hidden">
          <div className="flex flex-row gap-14 text-white justify-center md:mt-6 md:mb-8">
            <div className="border-[1.56px] border-[#1D5287] px-12 py-2 rounded-xl w-[334.337px] h-[292.16867px] ">
              <div className="md:leading-[1.2]">
                <div>
                  <Image
                    src="/cpa/bridge-course/university.svg"
                    alt="bridge course"
                    className="mx-[40%] py-8"
                    width={64}
                    height={64}
                    priority
                  />
                </div>
                <div className="mt-3 md:text-[22px] text-center md:leading-[28px] max-md:text-4xl">
                  Online M.Com Program
                  <br /> from Jain University -
                </div>
                <div className=" md:text-[22px] font-bold text-center">
                  NAAC A++ University
                </div>
              </div>
            </div>
            <div className="border-[1.56px] border-[#1D5287] px-6 py-2 rounded-xl">
              <div className="md:leading-[1.2]">
                <Image
                  src="/cpa/bridge-course/integration.svg"
                  alt="bridge course"
                  className="mx-[40%] py-8"
                  width={64}
                  height={64}
                  priority
                />
                <div className="mt-3 md:text-[22px] text-center md:leading-[28px]">
                  Fully integrated with the
                  <br /> Miles CPA exam coursework -<br />
                </div>
                <div className=" md:text-[22px] font-bold text-center">
                  no extra studies beyond
                  <br /> CPA prep
                </div>
              </div>
            </div>
            <div className="border-[1.56px] border-[#1D5287] px-12 py-2 rounded-xl">
              <div className="md:leading-[1.2]">
                <Image
                  src="/cpa/bridge-course/clock.svg"
                  alt="bridge course"
                  className="mx-[40%] py-8"
                  width={64}
                  height={64}
                  priority
                />
                <div className="mt-3 md:text-[22px] text-center md:leading-[28px] max-md:text-4xl">
                  Appear for the CPA exam
                  <br /> alongside the program -
                </div>
                <div className=" md:text-[22px] font-bold text-center">
                  no waiting till program
                  <br /> completion
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile */}

        <div className="md:hidden flex overflow-hidden w-full flex-col justify-center px-8 py-16 text-white shadow-xl bg-slate-900 max-md:px-5">
          <div className="flex flex-col items-center self-center w-full text-6xl font-semibold tracking-tighter text-center  max-md:max-w-full max-md:text-4xl">
            <div className="flex flex-col max-w-full w-[786px] max-md:text-4xl">
              <div className="mr-3.5 ml-3 max-md:mr-2.5 max-md:max-w-full text-2xl bg-[url(/home/wqv_hr_mob.png)] bg-bottom bg-no-repeat pb-3">
                CPA = U.S. Equivalent of CA
              </div>
            </div>
          </div>
          <div className="flex  gap-4 items-center mt-16 max-md:mt-10 max-md:max-w-full">
            <div className="flex flex-col justify-center items-center self-stretch px-3 py-8 my-auto rounded-2xl border border-[#1D5287] border-solid bg-slate-900 bg-opacity-20 w-[156px]  shadow-[99px_131px_46px_0px_rgba(4,84,175,0.00),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.10)] ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.5 1.875H6.75C5.85489 1.875 4.99645 2.23058 4.36351 2.86351C3.73058 3.49645 3.375 4.35489 3.375 5.25V21C3.375 21.2984 3.49353 21.5845 3.7045 21.7955C3.91548 22.0065 4.20163 22.125 4.5 22.125H18C18.2984 22.125 18.5845 22.0065 18.7955 21.7955C19.0065 21.5845 19.125 21.2984 19.125 21C19.125 20.7016 19.0065 20.4155 18.7955 20.2045C18.5845 19.9935 18.2984 19.875 18 19.875H5.625V19.5C5.625 19.2016 5.74353 18.9155 5.9545 18.7045C6.16548 18.4935 6.45163 18.375 6.75 18.375H19.5C19.7984 18.375 20.0845 18.2565 20.2955 18.0455C20.5065 17.8345 20.625 17.5484 20.625 17.25V3C20.625 2.70163 20.5065 2.41548 20.2955 2.2045C20.0845 1.99353 19.7984 1.875 19.5 1.875ZM11.25 4.125H14.625V9.65625L13.6397 8.86781C13.4402 8.70806 13.1922 8.62102 12.9366 8.62102C12.681 8.62102 12.433 8.70806 12.2334 8.86781L11.25 9.65625V4.125ZM18.375 16.125H6.75C6.36669 16.1243 5.98612 16.1896 5.625 16.3181V5.25C5.625 4.95163 5.74353 4.66548 5.9545 4.4545C6.16548 4.24353 6.45163 4.125 6.75 4.125H9V12C8.99996 12.212 9.0598 12.4196 9.17263 12.5991C9.28546 12.7785 9.4467 12.9224 9.63775 13.0142C9.82881 13.1061 10.0419 13.142 10.2525 13.118C10.4631 13.094 10.6627 13.0109 10.8281 12.8784L12.9366 11.1909L15.0469 12.8784C15.2123 13.0109 15.4119 13.094 15.6225 13.118C15.8331 13.142 16.0462 13.1061 16.2372 13.0142C16.4283 12.9224 16.5895 12.7785 16.7024 12.5991C16.8152 12.4196 16.875 12.212 16.875 12V4.125H18.375V16.125Z"
                  fill="#3174d6"
                />
              </svg>
              <div className="self-stretch mt-5 text-[16px] font-medium tracking-tighter text-center ">
                Only <br />4 exams
              </div>
              <div className="mt-5 text-[14px] tracking-tighter">
                Accounting | Auditing | Taxation | Business
              </div>
            </div>
            <div className="flex flex-col justify-center items-center self-stretch px-3 py-8 my-auto rounded-2xl border border-[#1D5287] border-solid bg-slate-900 bg-opacity-20 w-[156px]  shadow-[99px_131px_46px_0px_rgba(4,84,175,0.00),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.10)] ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.5 2.625H17.625V2.25C17.625 1.95163 17.5065 1.66548 17.2955 1.4545C17.0845 1.24353 16.7984 1.125 16.5 1.125C16.2016 1.125 15.9155 1.24353 15.7045 1.4545C15.4935 1.66548 15.375 1.95163 15.375 2.25V2.625H8.625V2.25C8.625 1.95163 8.50647 1.66548 8.2955 1.4545C8.08452 1.24353 7.79837 1.125 7.5 1.125C7.20163 1.125 6.91548 1.24353 6.7045 1.4545C6.49353 1.66548 6.375 1.95163 6.375 2.25V2.625H4.5C4.00272 2.625 3.52581 2.82254 3.17417 3.17417C2.82254 3.52581 2.625 4.00272 2.625 4.5V19.5C2.625 19.9973 2.82254 20.4742 3.17417 20.8258C3.52581 21.1775 4.00272 21.375 4.5 21.375H19.5C19.9973 21.375 20.4742 21.1775 20.8258 20.8258C21.1775 20.4742 21.375 19.9973 21.375 19.5V4.5C21.375 4.00272 21.1775 3.52581 20.8258 3.17417C20.4742 2.82254 19.9973 2.625 19.5 2.625ZM6.375 4.875C6.375 5.17337 6.49353 5.45952 6.7045 5.6705C6.91548 5.88147 7.20163 6 7.5 6C7.79837 6 8.08452 5.88147 8.2955 5.6705C8.50647 5.45952 8.625 5.17337 8.625 4.875H15.375C15.375 5.17337 15.4935 5.45952 15.7045 5.6705C15.9155 5.88147 16.2016 6 16.5 6C16.7984 6 17.0845 5.88147 17.2955 5.6705C17.5065 5.45952 17.625 5.17337 17.625 4.875H19.125V7.125H4.875V4.875H6.375ZM4.875 19.125V9.375H19.125V19.125H4.875Z"
                  fill="#3174d6"
                />
              </svg>
              <div className="self-stretch mt-5 text-[16px] font-medium tracking-tighter text-center ">
                12 <br />
                months
              </div>
              <div className="mt-5 text-[14px] tracking-tighter text-center">
                1 exam every 3 months
              </div>
            </div>
          </div>
          <div className="flex  gap-4 items-center mt-16 max-md:mt-10 max-md:max-w-full">
            <div className="flex flex-col justify-center items-center self-stretch px-3 py-8 my-auto rounded-2xl border border-[#1D5287] border-solid bg-slate-900 bg-opacity-20 w-[156px]  shadow-[99px_131px_46px_0px_rgba(4,84,175,0.00),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.10)] ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.375 9.375C9.375 9.07663 9.49353 8.79048 9.7045 8.5795C9.91548 8.36853 10.2016 8.25 10.5 8.25H13.5C13.7984 8.25 14.0845 8.36853 14.2955 8.5795C14.5065 8.79048 14.625 9.07663 14.625 9.375C14.625 9.67337 14.5065 9.95952 14.2955 10.1705C14.0845 10.3815 13.7984 10.5 13.5 10.5H10.5C10.2016 10.5 9.91548 10.3815 9.7045 10.1705C9.49353 9.95952 9.375 9.67337 9.375 9.375ZM22.125 6.375V18.375C22.125 18.8723 21.9275 19.3492 21.5758 19.7008C21.2242 20.0525 20.7473 20.25 20.25 20.25H3.75C3.25272 20.25 2.77581 20.0525 2.42417 19.7008C2.07254 19.3492 1.875 18.8723 1.875 18.375V6.375C1.875 5.87772 2.07254 5.40081 2.42417 5.04917C2.77581 4.69754 3.25272 4.5 3.75 4.5H7.125V3.75C7.125 3.05381 7.40156 2.38613 7.89384 1.89384C8.38613 1.40156 9.05381 1.125 9.75 1.125H14.25C14.9462 1.125 15.6139 1.40156 16.1062 1.89384C16.5984 2.38613 16.875 3.05381 16.875 3.75V4.5H20.25C20.7473 4.5 21.2242 4.69754 21.5758 5.04917C21.9275 5.40081 22.125 5.87772 22.125 6.375ZM9.375 4.5H14.625V3.75C14.625 3.65054 14.5855 3.55516 14.5152 3.48484C14.4448 3.41451 14.3495 3.375 14.25 3.375H9.75C9.65054 3.375 9.55516 3.41451 9.48483 3.48484C9.41451 3.55516 9.375 3.65054 9.375 3.75V4.5ZM4.125 6.75V10.0528C6.5527 11.3323 9.25575 12.0007 12 12C14.7444 12.0006 17.4475 11.3319 19.875 10.0519V6.75H4.125ZM19.875 18V12.5569C17.3997 13.6732 14.7153 14.2503 12 14.25C9.28463 14.2505 6.60022 13.6733 4.125 12.5569V18H19.875Z"
                  fill="#3174d6"
                />
              </svg>
              <div className="self-stretch mt-5 text-[16px] font-medium tracking-tighter text-center ">
                Pursue with <br />
                full time job
              </div>
              <div className="mt-5 text-[14px] tracking-tighter">
                20 hrs study/week
              </div>
            </div>
            <div className="flex flex-col justify-center items-center self-stretch py-8 my-auto rounded-2xl border border-[#1D5287] border-solid bg-slate-900 bg-opacity-20 w-[156px]  shadow-[99px_131px_46px_0px_rgba(4,84,175,0.00),64px_84px_42px_0px_rgba(4,84,175,0.01),36px_47px_35px_0px_rgba(4,84,175,0.05),16px_21px_26px_0px_rgba(4,84,175,0.09),4px_5px_14px_0px_rgba(4,84,175,0.10)] ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7.45406 13.5459C7.34942 13.4413 7.2664 13.3171 7.20977 13.1803C7.15314 13.0436 7.12399 12.8971 7.12399 12.7491C7.12399 12.6011 7.15314 12.4545 7.20977 12.3178C7.2664 12.1811 7.34942 12.0568 7.45406 11.9522C7.55871 11.8475 7.68294 11.7645 7.81967 11.7079C7.9564 11.6513 8.10294 11.6221 8.25094 11.6221C8.39893 11.6221 8.54548 11.6513 8.6822 11.7079C8.81893 11.7645 8.94317 11.8475 9.04781 11.9522L10.5 13.4062L14.9541 8.95125C15.1654 8.73991 15.4521 8.62117 15.7509 8.62117C16.0498 8.62117 16.3365 8.73991 16.5478 8.95125C16.7592 9.16259 16.8779 9.44924 16.8779 9.74813C16.8779 10.047 16.7592 10.3337 16.5478 10.545L11.2978 15.795C11.1933 15.8999 11.0691 15.9831 10.9324 16.0399C10.7956 16.0967 10.649 16.1259 10.5009 16.1259C10.3529 16.1259 10.2063 16.0967 10.0695 16.0399C9.93277 15.9831 9.80858 15.8999 9.70406 15.795L7.45406 13.5459ZM21.375 4.5V19.5C21.375 19.9973 21.1775 20.4742 20.8258 20.8258C20.4742 21.1775 19.9973 21.375 19.5 21.375H4.5C4.00272 21.375 3.52581 21.1775 3.17417 20.8258C2.82254 20.4742 2.625 19.9973 2.625 19.5V4.5C2.625 4.00272 2.82254 3.52581 3.17417 3.17417C3.52581 2.82254 4.00272 2.625 4.5 2.625H19.5C19.9973 2.625 20.4742 2.82254 20.8258 3.17417C21.1775 3.52581 21.375 4.00272 21.375 4.5ZM19.125 4.875H4.875V19.125H19.125V4.875Z"
                  fill="#3174d6"
                />
              </svg>
              <div className="mt-5 text-[16px] font-medium tracking-tighter text-center ">
                Next batch starts from Sep 7
              </div>
              <div className="mt-5 text-[14px] tracking-tighter">Fees ₹99k</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BridgeProgram;
